/**
 * Replace null values with empty strings
 */
export const getNonNull = <T extends Record<string, any>>(obj: T): Record<keyof T, string> => {
  return Object.keys({ ...obj }).reduce<T>((acc, key) => {
    acc[key as keyof typeof acc] = obj[key] ?? ''
    return acc
  }, {} as T)
}
